const FormMessage = ({message}) => {
    return   <div className='w-100 text-center lead d-flex' dangerouslySetInnerHTML={{ __html: message }} />

}

export default FormMessage
